var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellInverted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.22945 7.46282C7.67712 5.1605 9.67608 3.5 12 3.5C14.3239 3.5 16.3229 5.1605 16.7705 7.46282L16.8943 8.09934C16.9646 8.46083 17 8.82836 17 9.19675V10.7483C17 11.9103 17.4625 13.0236 18.2836 13.8379L19.4 14.9451C19.7838 15.3258 20 15.8535 20 16.3967C20 17.5483 19.0753 18.5 17.9347 18.5H6.06533C4.92468 18.5 4 17.5483 4 16.3967C4 15.8535 4.2162 15.3258 4.6 14.9451L5.7164 13.8379C6.53748 13.0236 7 11.9103 7 10.7483V9.19675C7 8.82836 7.03539 8.46083 7.10568 8.09934L7.22945 7.46282ZM6.00504 16.3724C6.00702 16.3676 6.00933 16.3642 6.00933 16.3642L7.12475 15.258C8.32656 14.0661 9 12.4407 9 10.7483V9.19675C9 8.95644 9.02309 8.71675 9.06891 8.48108L9.19268 7.84456C9.46013 6.46911 10.6466 5.5 12 5.5C13.3534 5.5 14.5399 6.46911 14.8073 7.84456L14.9311 8.48108C14.9769 8.71675 15 8.95644 15 9.19675V10.7483C15 12.4407 15.6734 14.0661 16.8752 15.258L17.9907 16.3642C17.9907 16.3642 17.993 16.3676 17.995 16.3724C17.9984 16.3809 18 16.3898 18 16.3967C18 16.4296 17.9879 16.4587 17.9657 16.4813C17.9552 16.492 17.9464 16.4969 17.9425 16.4986C17.9402 16.4996 17.939 16.5 17.9347 16.5H6.06533C6.061 16.5 6.0598 16.4996 6.05751 16.4986C6.05362 16.4969 6.04479 16.492 6.03425 16.4813C6.01212 16.4587 6 16.4296 6 16.3967C6 16.3898 6.00156 16.3809 6.00504 16.3724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 21.5C13.1046 21.5 14 20.6046 14 19.5H10C10 20.6046 10.8954 21.5 12 21.5Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellInverted);
export default __webpack_public_path__ + "static/media/bell-inverted.2bf3af49841f39e21fe37e5c0e474f8f.svg";
export { ForwardRef as ReactComponent };